import {
  CommonActions,
  RouteProp,
  StackActions,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { useAuthModel } from '@models/AuthModel';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { useDeepLinking } from './useDeepLinking';
import { screens } from '../navigation/screens';
import type { PersonalizationStackParamListType } from '../navigation/types';

type NavigationPropType =
  NativeStackNavigationProp<PersonalizationStackParamListType>;
type RoutePropType = RouteProp<
  PersonalizationStackParamListType,
  any
>;

const SCREENS_ORDER = [
  screens.SuccessfulSignIn,
  screens.SkillLevelQuestionnaire,
  screens.Questionnaire,
  // screens.UsersSuggestion,
  screens.InviteSuggestion,
];

export function usePersonalizationNavigation() {
  const viewer = useViewerModel();
  const deepLinking = useDeepLinking();
  const nav = useNavigation<NavigationPropType>();
  const route = useRoute<RoutePropType>();
  const auth = useAuthModel();

  function navigateToSkillLevelQuestionnaire() {
    nav.replace(screens.SkillLevelQuestionnaire);
  }

  function navigateToQuestionnaire() {
    nav.replace(screens.Questionnaire);
  }

  function navigateToInviteSuggestion() {
    nav.replace(screens.InviteSuggestion);
  }

  // function navigateToUsersSuggestion() {
  //   nav.replace(screens.UsersSuggestion);
  // }

  function navigateToTutorial() {
    nav.dispatch(
      StackActions.replace(screens.HubNavigator, {
        screen: screens.Tutorial,
        params: { id: route.params?.inviteVideoId },
      }),
    );
  }

  function navigateToHome() {
    nav.dispatch(StackActions.replace(screens.TabNavigator));
  }

  function navigateByDeepLinkAction(action: CommonActions.Action) {
    nav.dispatch({ ...action, type: 'REPLACE' });
    deepLinking.clear();
  }

  function navigateToNextScreen() {
    const action = deepLinking.getInitialAction();

    if (
      SCREENS_ORDER.indexOf(route.name) === 0 &&
      viewer.currentUser?.settings.isNeedToAskSkillLevel
    ) {
      navigateToSkillLevelQuestionnaire();
    } else if (
      SCREENS_ORDER.indexOf(route.name) < 2 &&
      viewer.currentUser?.settings.isNeedToAskQuest
    ) {
      navigateToQuestionnaire();
    }
    /* Hiding the "Users Suggestion" screen for now according
      to requirements in Jira ticket SYN-1387
      if we will return this screen, we need to set the correct index in condition
    */
    // else if (
    //   SCREENS_ORDER.indexOf(route.name) <= 1 &&
    //   viewer.currentUser?.settings.isNeedToSuggestUsers
    // ) {
    //   navigateToUsersSuggestion();
    // }
    else if (
      SCREENS_ORDER.indexOf(route.name) <= 2 &&
      auth.isFirstLogin
    ) {
      navigateToInviteSuggestion();
    } else if (route.params?.inviteVideoId) {
      navigateToTutorial();
    } else if (action) {
      navigateByDeepLinkAction(action);
    } else {
      navigateToHome();
    }
  }

  return {
    navigateToNextScreen,
    navigateToHome,
  };
}
